import { Component, HostListener } from "@angular/core";
import { MessageService } from "../../../../shared/services/message.service";
import { GameService } from "../../../../shared/services/game.service";
import { State } from "../../../../shared/interfaces/state.interface";
import { takeUntil } from "rxjs/operators";
import { CopyService } from "../../../../shared/services/copy.service";
import { Router } from "@angular/router";
import { MemeTriggerService } from "../../../../shared/services/meme-trigger.service";
import { MemeState } from "../../../../shared/interfaces/memestate.interface";

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent {
  private gameState: State;
  private get isAlone(): boolean {
    return this.gameService.isAlone;
  }

  private currentURL: string;
  private gridMap: Map<number, string>;
  private lastMemeState: MemeState;

  constructor(
    private gameService: GameService,
    private messageService: MessageService,
    private copyService: CopyService,
    private memeService: MemeTriggerService,
    private router: Router
  ) {
    this.gameService.stateUpdateReceived$
      .pipe(takeUntil(this.gameService.onDestroy$))
      .subscribe((newState: State) => {
        this.lastMemeState = newState.MemeState;
        this.gameState = newState;
        this.currentURL = this.gameService.baseUrl + this.router.url.substr(1);
        this.votesCasted();
      });

    this.gridMap = new Map<number, string>();
    [10, 6, 0, 4, 8].forEach((num) => {
      this.gridMap.set(num, "display-top");
    });
    [11, 7, 1, 5, 9].forEach((num) => {
      this.gridMap.set(num, "display-bottom");
    });
    this.gridMap.set(13, "display-left display-left-top");
    this.gridMap.set(14, "display-left display-left-bottom");
    this.gridMap.set(12, "display-right display-right-top");
    this.gridMap.set(15, "display-right display-right-bottom");
    this.gridMap.set(3, "display-left display-left-middle");
    this.gridMap.set(2, "display-right display-right-middle");
  }

  async showVotes() {
    await this.gameService.showVotes().catch(() => {
      this.messageService.showError(
        "Er is iets misgegaan tijdens het bekijken van de kaarten, herlaad de pagina en probeer het opnieuw"
      );
    });
  }

  public votesCasted(): boolean {
    return this.gameState.Votes.some((vote) => vote.Card != null);
  }

  private checkShowAgreementMeme(): boolean {
    if (this.lastMemeState == null) {
      return false;
    }

    return this.lastMemeState.similarVote;
  }

  invitePlayers() {
    this.copyService.copyMessage(this.currentURL);
    this.messageService.showSuccess("Link gekopiëerd");
  }

  checkHasVoted() {
    return this.gameService.hasVoted;
  }

  getState() {
    return this.gameService.gameState;
  }

  getGridArea(index: number) {
    return "player-" + index;
  }

  giveClass(index: number) {
    return this.gridMap.get(index);
  }
}
